import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { Col, Row } from 'reactstrap';
import LinkDetail from './components/LinkDetail';
import { useHistory, useLocation } from 'react-router-dom';

const ExamplePage = () => {
  const location = useLocation();
  
  useEffect(() => {
    if(location.state) {
      console.log("AAA_LINK", location.state.name);
    }
  }, [])

  return (
    <div className="dashboard-container">
      <Row>
        <Col md={12}>
          <div style={{justifyContent: 'space-between', display: 'flex'}}>
            <h3 className="page-title">{location.state ? location.state.name : "Link Detail"}</h3>
          </div>
        </Col>
      </Row>
      <Row>
        <LinkDetail payment={location.state.payment} />
      </Row>
    </div>
  )
};

export default ExamplePage;
